import type {ClientCompanyBillingInfoParam, ClientCompanyBillingInfoResource} from '@api';

export function clientCompanyBillingInitData(clientCompanyBillingInformation: ClientCompanyBillingInfoResource): ClientCompanyBillingInfoParam {
    const billingInfo = clientCompanyBillingInformation || {};

    return {
        billingContact: billingInfo.billingContact || '',
        otherBillingContacts: billingInfo.otherBillingContacts ?? [],
    };
}
